import {
  PenpalContextProvider,
  usePenpal,
} from "@saasquatch/integration-boilerplate-react";
import {
  ButtonView,
  CSSVariables,
  FieldLabelTextView,
  InputView,
  LinkRules,
  LoadingSpinner,
  RegularTextView,
} from "@impactinc/ui-react-components";
import "@impactinc/ui-react-components/dist/uirc.css";
import React, { useState } from "react";
import { render } from "react-dom";
import "./styles.css";
// @ts-expect-error -- need to fix upstream types
import { initializeThemeSwitcherParent } from "@impactinc/theme-switcher";
import "@impactinc/frontend-theme-tokens/primitives";
import "@impactinc/frontend-theme-tokens/fonts";
import "@impactinc/frontend-theme-tokens/themes";

initializeThemeSwitcherParent();

type EditorState = {
  formData: {
    appsFlyerLink: string;
  };
};

const isEmpty = (value: { [key: string]: string }) => {
  return (
    !value ||
    (Object.keys(value).length === 0 && value.constructor === Object) ||
    !value.appsflyerLink
  );
};

function Index() {
  const penpal = usePenpal();
  const config = penpal.integrationConfig as { appsflyerLink: string };
  const useDefault = isEmpty(config);

  const [saving, setSaving] = useState(false);
  const [formData, setFormData] = useState({
    appsflyerLink: config?.appsflyerLink || "",
  });
  const [error, setError] = useState("");

  function validateLink(formData: any) {
    const input = formData.appsflyerLink;
    if (
      (input &&
        !(input.startsWith("https://") || input.startsWith("http://"))) ||
      input === "" ||
      input === undefined
    ) {
      const error = "You must enter a valid AppsFlyer attribution link";
      setError(error);
      return error;
    }
    setError("");
    return "";
  }

  async function submit(e: React.MouseEvent) {
    if (!e.isTrusted) return;

    setSaving(true);
    if (validateLink(formData)) return setSaving(false);

    // @ts-ignore
    await penpal.saveIntegrationConfig(formData);
    setSaving(false);
  }

  function onChange(event: React.ChangeEvent<HTMLInputElement>) {
    setFormData({ appsflyerLink: event.target.value });
    validateLink({ appsflyerLink: event.target.value });
  }

  return (
    <div className="container">
      <div className="description">
        <RegularTextView>
          Connect your custom AppsFlyer OneLink attribution link for mobile
          redirection and deep linking.
          <br />
          <br />
          <FieldLabelTextView>Set Up Steps</FieldLabelTextView>
        </RegularTextView>
        <RegularTextView>
          <ol>
            <li>Create a OneLink Template in AppsFlyer</li>
            <li>
              Configure a custom link with your desired redirection settings
            </li>
            <li>
              Leave the Desktop redirection URL empty. This will be pulled from
              your {penpal.flavor === "impact" ? "Advocate" : "SaaSquatch"}{" "}
              program settings.
            </li>
            <li>Copy and paste the short URL for your custom link below. </li>
          </ol>
        </RegularTextView>
        <RegularTextView>
          <br />
          This link will be used as the redirct for all of your active
          {penpal.flavor === "impact" ? "Advocate" : "SaaSquatch"} programs.
          <br />
        </RegularTextView>
      </div>
      <label htmlFor="appsFlyerLink">
        <FieldLabelTextView>AppsFlyer Base Attribution Link</FieldLabelTextView>
      </label>
      <br />
      <InputView
        name="appsflyerLink"
        onChange={onChange}
        value={config.appsflyerLink}
        autoFocus
        placeholder={"https://app.onelink.me/templateId/linkId"}
        errors={!!error}
      />
      {error && <li style={{ color: "#c13333" }}>{error}</li>}
      <ButtonView
        buttonType="primary"
        type="submit"
        onClick={submit}
        disabled={!!error}
        loading={saving}
        style={{ marginTop: "12px" }}
      >
        Save
      </ButtonView>
    </div>
  );
}

function App() {
  return (
    <PenpalContextProvider
      loading={<LoadingSpinner.Large />}
      fallback={
        <p>Integration configuration must be done inside the product.</p>
      }
    >
      <CSSVariables /> <LinkRules />
      <Index />
    </PenpalContextProvider>
  );
}

const rootElement = document.getElementById("root");
render(<App />, rootElement);
